<template>
    <div class="cost-center">
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="成本中心代码">
                        <el-input v-model="searchForm.code" placeholder="成本中心代码" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="成本中心名称">
                        <el-input v-model="searchForm.name" placeholder="成本中心名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="级别">
                        <el-select v-model="searchForm.level" placeholder="级别" clearable>
                            <el-option label="全部" value=""></el-option>
                            <el-option label="一级" :value="1"></el-option>
                            <el-option label="二级" :value="2"></el-option>
                            <el-option label="三级" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSearch" size="mini">查询</el-button>
                        <el-button type="success" @click="handleCreate" size="mini">新增</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                <el-table
                    size="mini"
                    stripe
                    :data="tableData"
                    v-loading="loading"
                    :height="tableConfig.height"
                    style="width: 100%"
                    row-key="id"
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                    <el-table-column
                        prop="code"
                        label="成本中心代码"
                        width="200">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="成本中心名称"
                        width="250">
                    </el-table-column>
                    <el-table-column
                        prop="level"
                        label="级别"
                        width="100">
                        <template slot-scope="scope">
                            <el-tag size="mini" :type="getLevelType(scope.row.level)">
                                {{getLevelText(scope.row.level)}}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="sortOrder"
                        label="排序"
                        width="100">
                    </el-table-column>
                    <el-table-column
                        prop="remark"
                        label="备注"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        prop="createTime"
                        label="创建时间"
                        width="160">
                    </el-table-column>
                    <el-table-column label="操作" width="200" align="right" fixed="right">
                        <template slot-scope="scope">
                            <el-button
                                size="mini" type="text"
                                @click="handleEdit(scope.row)">编辑</el-button>
                            <el-divider direction="vertical"></el-divider>
                            <el-button
                                size="mini" type="text"
                                @click="handleAddChild(scope.row)">添加子级</el-button>
                            <el-divider direction="vertical"></el-divider>
                            <el-button
                                size="mini"
                                type="text"
                                style="color: #F56C6C;"
                                @click="handleDelete(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </main>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" width="600px">
            <el-form ref="form" :model="form" :rules="rules" label-width="120px" size="mini">
                <el-form-item label="成本中心代码" prop="code">
                    <el-input v-model="form.code" placeholder="请输入成本中心代码" clearable></el-input>
                </el-form-item>
                <el-form-item label="成本中心名称" prop="name">
                    <el-input v-model="form.name" placeholder="请输入成本中心名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="上级成本中心" v-if="form.level1Id || form.level2Id">
                    <el-input v-model="parentName" disabled></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="sortOrder">
                    <el-input-number v-model="form.sortOrder" :min="0" controls-position="right" style="width: 100%;"></el-input-number>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
                <el-button type="primary" @click="onSubmit" size="mini">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
const HEIGHT_OFFSET = 118;

export default {
    data() {
        return {
            tableConfig: {
                height: 0,
            },
            searchForm: {
                code: "",
                name: "",
                level: ""
            },
            loading: false,
            tableData: [],
            dialogVisible: false,
            dialogTitle: "新增成本中心",
            form: {
                id: "",
                code: "",
                name: "",
                level1Id: "",
                level2Id: "",
                sortOrder: 0,
                remark: ""
            },
            parentName: "",
            rules: {
                code: [
                    { required: true, message: '请输入成本中心代码', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '请输入成本中心名称', trigger: 'blur' }
                ]
            }
        }
    },
    mounted() {
        this.onSearch();
        window.addEventListener("resize", this.setTableHeight);
        setTimeout(() => {
            this.setTableHeight();
        }, 500);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.setTableHeight);
    },
    methods: {
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            if (tablePosition) {
                const {top} = tablePosition.getBoundingClientRect();
                this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
            }
        },
        getLevelType(level) {
            const typeMap = {
                1: 'primary',
                2: 'success',
                3: 'warning'
            };
            return typeMap[level] || 'info';
        },
        getLevelText(level) {
            const textMap = {
                1: '一级',
                2: '二级',
                3: '三级'
            };
            return textMap[level] || '';
        },
        onSearch() {
            this.loading = true;
            const params = {};
            if (this.searchForm.code) params.code = this.searchForm.code;
            if (this.searchForm.name) params.name = this.searchForm.name;
            if (this.searchForm.level !== "") params.level = this.searchForm.level;

            this.$axios.post("/admin/qiqi/costCenter/list", params)
                .then(response => {
                    const resp = response.data;
                    if (resp.header.status == 0) {
                        this.tableData = this.buildTree(resp.data);
                    } else {
                        this.$notify.error({
                            title: '错误',
                            message: resp.header.msg || '查询失败'
                        });
                    }
                })
                .catch(error => {
                    this.$notify.error({
                        title: '错误',
                        message: '查询失败'
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        buildTree(data) {
            if (!data || data.length === 0) {
                return [];
            }
            
            const level1 = data.filter(item => item.level == 1);
            const level2 = data.filter(item => item.level == 2);
            const level3 = data.filter(item => item.level == 3);

            level2.forEach(l2 => {
                l2.children = level3.filter(l3 => l3.level2Id === l2.id);
            });

            level1.forEach(l1 => {
                l1.children = level2.filter(l2 => l2.level1Id === l1.id);
            });

            return level1;
        },
        handleCreate() {
            this.dialogTitle = "新增成本中心";
            this.form = {
                id: "",
                code: "",
                name: "",
                level1Id: "",
                level2Id: "",
                sortOrder: 0,
                remark: ""
            };
            this.parentName = "";
            this.dialogVisible = true;
        },
        handleAddChild(row) {
            if (row.level === 3) {
                this.$message.warning('三级成本中心不能再添加子级');
                return;
            }
            this.dialogTitle = row.level === 1 ? "新增二级成本中心" : "新增三级成本中心";
            this.form = {
                id: "",
                code: "",
                name: "",
                level1Id: row.level === 1 ? row.id : row.level1Id,
                level2Id: row.level === 2 ? row.id : "",
                sortOrder: 0,
                remark: ""
            };
            this.parentName = row.name;
            this.dialogVisible = true;
        },
        handleEdit(row) {
            this.dialogTitle = "编辑成本中心";
            this.form = {
                id: row.id,
                code: row.code,
                name: row.name,
                level1Id: row.level1Id || "",
                level2Id: row.level2Id || "",
                sortOrder: row.sortOrder,
                remark: row.remark || ""
            };
            this.parentName = "";
            this.dialogVisible = true;
        },
        onSubmit() {
            const that = this;
            this.$refs.form.validate(valid => {
                if (valid) {
                    const url = this.form.id ? "/admin/qiqi/costCenter/update" : "/admin/qiqi/costCenter";
                    this.$axios.post(url, this.form)
                        .then(response => {
                            const resp = response.data;
                            if (resp.header.status == 0) {
                                that.$notify({
                                    title: '成功',
                                    message: '保存成功',
                                    type: 'success'
                                });
                                that.dialogVisible = false;
                                that.onSearch();
                            } else {
                                that.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg || '保存失败'
                                });
                            }
                        })
                        .catch(error => {
                            that.$notify.error({
                                title: '错误',
                                message: '保存失败'
                            });
                        });
                }
            });
        },
        handleDelete(row) {
            this.$confirm('确定要删除该成本中心吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.post("/admin/qiqi/costCenter/delete", { id: row.id })
                    .then(response => {
                        const resp = response.data;
                        if (resp.header.status == 0) {
                            this.$notify({
                                title: '成功',
                                message: '删除成功',
                                type: 'success'
                            });
                            this.onSearch();
                        } else {
                            this.$notify.error({
                                title: '错误',
                                message: resp.header.msg || '删除失败'
                            });
                        }
                    })
                    .catch(error => {
                        this.$notify.error({
                            title: '错误',
                            message: '删除失败'
                        });
                    });
            }).catch(() => {});
        }
    }
}
</script>

<style scoped>
.cost-center {
    height: 100%;
}
.content {
    padding: 20px;
}
</style>
